import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import CacheBuster from 'react-cache-buster';
import appversion from '../package.json';
import reportWebVitals from './reportWebVitals';


const appVersion = appversion.version;


let pathname = window.location.pathname.toLowerCase();
 
// Check if the pathname is "/loan-programs" without a trailing slash
if (pathname === '/loan-programs' && !pathname.endsWith('/')) {
  // Redirect to the URL with the trailing slash
  window.location.href = `${window.location.href}/`;
} else if (pathname === '/loan-programs/') {
  // Redirect to the search URL
  let searchURL = window.location.href.toLowerCase();
  if (window.location.hostname === 'localhost') {
    searchURL = `http://${window.location.host}${pathname}home`;
  } else {
    searchURL = `https://${window.location.host}${pathname}home`;
  }
  window.location.href = searchURL;
}

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename={process.env.REACT_APP_BASENAME}>
      <CacheBuster
        currentVersion={appVersion}
        isEnabled={true} // If false, the library is disabled.
        isVerboseMode={false} // If true, the library writes verbose logs to console.
      >
        <App />
      </CacheBuster>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
